<div
  class="sh-card card no-gutter"
  [ngClass]="styleClass"
  [class.sh-u-full-height]="fullHeight"
>
  <div>
    @if (!headerText) {
      <ng-content select="[header]"></ng-content>
    }
    @if (headerText) {
      <h3
        class="sh-card__headline sh-h3"
        [ngClass]="headerClass"
        [innerHTML]="headerText"
        [attr.data-badge]="badgeText"
      ></h3>
    }
  </div>
  <div>
    <ng-content></ng-content>
  </div>
</div>
